var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":_vm.uploadUrl,"show-file-list":false,"on-success":_vm.handleAvatarSuccess,"before-upload":_vm.beforeAvatarUpload}},[(_vm.imgUrl)?[_c('img',{staticClass:"avatar",attrs:{"src":_vm.imgUrl}})]:_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }